module.exports = __webpack_public_path__ + "static/media/success-check.babf95aa.svg";